module.exports = __webpack_public_path__ + "static/media/pdf.f0a04fad.png";